import { Alert, Box, List, ListItem, Typography } from '@mui/material';
import WizardBackButton from 'pages/GettingStarted/Wizard/components/WizardBackLink';
import WizardGenerateButton from 'pages/GettingStarted/Wizard/components/WizardGenerateButton';
import WizardContentLayout from 'pages/GettingStarted/Wizard/Phases/WizardContentLayout';
import { WIZARD_PAGES } from 'pages/GettingStarted/Wizard/utils/consts';
import React, { FC } from 'react';
import { IWizardFlow, IWizardProps, WizardPhase } from 'types/wizard';
import WizardSuggestion from '../../components/WizardSuggestion';
import { useWizardUpdate } from '../../utils/hook';

const Apply: FC<IWizardProps> = (props) => {
	const { state } = props;
	const { flows, combinations } = state;
	const { update } = useWizardUpdate(state);

	const handleBack = React.useCallback(async () => {
		await update({
			phase: WizardPhase.Build,
			page:
				combinations.length === 1
					? WIZARD_PAGES.secondaryMethod
					: WIZARD_PAGES.suggestions
		});
	}, [combinations.length, update]);

	const selectedCombination = React.useMemo(
		() => combinations.find((combination) => combination.selected),
		[combinations]
	);

	return (
		<WizardContentLayout
			{...{ state }}
			backButton={<WizardBackButton onClick={handleBack} />}
			actionButton={<WizardGenerateButton {...props} />}
		>
			<Box
				display="flex"
				flexDirection={{ xs: 'column', sm: 'row' }}
				flexGrow={1}
			>
				<Box
					display="flex"
					flexDirection="column"
					pb={{
						xs: 4,
						sm: 0
					}}
				>
					<Box display="flex" flexDirection="column">
						<Typography variant="h6">
							{intl.tr('wizard.phase.build.apply.header')}
						</Typography>
						{flows && (
							<>
								<Typography variant="body1" pt={4}>
									{intl.tr('wizard.phase.build.apply.second.header')}
								</Typography>
								<List
									sx={{
										listStyleType: 'disc',
										paddingLeft: '1.5rem'
									}}
								>
									{(flows || []).map((flow: IWizardFlow) => (
										<ListItem key={flow.id}>
											<Box display="flex" flexDirection="column">
												<Typography
													variant="subtitle1"
													pt={1}
													fontWeight="bold"
													sx={{ display: 'list-item' }}
												>
													{flow.title}
												</Typography>
												<Typography variant="body1">
													{flow.description}
												</Typography>
											</Box>
										</ListItem>
									))}
								</List>
								<Alert
									severity="warning"
									sx={{
										marginTop: 3,
										maxWidth: 600
									}}
								>
									{intl.tr('wizard.phase.build.apply.flows.alert')}
								</Alert>
							</>
						)}
					</Box>
				</Box>
				<Box
					display="flex"
					flexDirection="row"
					alignContent="center"
					justifyContent="center"
					flexGrow={1}
				>
					<Box maxHeight={545} maxWidth={360}>
						{selectedCombination && (
							<WizardSuggestion combination={selectedCombination!} disabled />
						)}
					</Box>
				</Box>
			</Box>
		</WizardContentLayout>
	);
};

export default Apply;
